//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/build/client.js";

//
// Component
//

export function initialiseIssuePenaltyForm(issuePenaltyForm: HTMLFormElement)
{
	const typeSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(issuePenaltyForm, `select[name="type"]`);

	const banDurationRow = BrowserUtilities.ElementClientLib.getElementOrThrow(issuePenaltyForm, ".row.ban-duration");

	const banDurationSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(issuePenaltyForm, `select[name="banDuration"]`);

	const reasonSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(issuePenaltyForm, `select[name="reason"]`);

	const customReasonRow = BrowserUtilities.ElementClientLib.getElementOrThrow(issuePenaltyForm, ".row.custom-reason");

	initialiseForm(issuePenaltyForm);

	typeSelect.addEventListener("change",
		() =>
		{
			if (typeSelect.value == "0")
			{
				banDurationRow.classList.add("show");

				banDurationSelect.setAttribute("required", "");
			}
			else
			{
				banDurationRow.classList.remove("show");

				banDurationSelect.removeAttribute("required");
			}
		});

	reasonSelect.addEventListener("change",
		() =>
		{
			if (reasonSelect.value == "custom")
			{
				customReasonRow.classList.add("show");

				customReasonRow.setAttribute("required", "");
			}
			else
			{
				customReasonRow.classList.remove("show");

				customReasonRow.removeAttribute("required");
			}
		});

	issuePenaltyForm.classList.add("initialised");
}

export function initialiseIssuePenaltyForms()
{
	const issuePenaltyForms = document.querySelectorAll<HTMLFormElement>(".component-issue-penalty-form:not(.initialised)");

	console.log("[IssuePenaltyForm] Initialising " + issuePenaltyForms.length + " instances...");

	for (const issuePenaltyForm of issuePenaltyForms)
	{
		try
		{
			initialiseIssuePenaltyForm(issuePenaltyForm);
		}
		catch (error)
		{
			console.error("[IssuePenaltyForm] Error initialising:", issuePenaltyForm, error);
		}
	}
}